// @ts-nocheck
import * as React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import compareAsc from 'date-fns/compareAsc';
import formatISO9075 from 'date-fns/formatISO9075';
import AlertMessage from '../../../../Alias/AlertMessage';
import { Box, Button, TextField, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export default function ProgramarEnvio({ handleClose, setForm, form, enviar }) {
  const [value, setValue] = React.useState(new Date());
  const [alert, setAlert] = React.useState(null);

  const fechaEsValida = (fecha) => fecha instanceof Date && !isNaN(fecha.valueOf());
  const fechaEsPasada = (fecha) => fechaEsValida(fecha) && compareAsc(fecha, new Date()) === -1;

  const aceptar = () => {
    if (!fechaEsValida(value) || fechaEsPasada(value)) {
      setAlert({ status: 'error', message: 'La fecha introducida es inválida o antigua.' });
      return;
    }
    setForm({ ...form, fechaProgramada: value });
    enviar(value);
    handleClose();
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CalendarMonthIcon color="primary" />
        <Typography variant="h6">Programar Envío</Typography>
      </Box>

      <AlertMessage alert={alert} setAlert={setAlert} />

      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DateTimePicker
          label="Fecha y hora de envío"
          value={value}
          onChange={setValue}
          minDateTime={new Date()}
          inputFormat="dd/MM/yyyy HH:mm"
          ampm={false}
          renderInput={(params) => <TextField {...params} fullWidth />}
        />
      </LocalizationProvider>

      {fechaEsValida(value) && !fechaEsPasada(value) && (
        <Typography variant="body2" color="text.secondary">
          La difusión se enviará el <strong>{formatISO9075(value)}</strong>.
        </Typography>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
        <Button sx={{ textTransform: 'none' }} variant="outlined" onClick={handleClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={aceptar}
          disabled={!fechaEsValida(value) || fechaEsPasada(value)}
          sx={{ textTransform: 'none' }}
        >
          Confirmar
        </Button>
      </Box>
    </Box>
  );
}
